var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { PenpalIframe } from '@robinpowered/common-lib';
import { ExpandedDrawer } from './ExpandedDrawer';
import { useWorkplaceServiceRequestContext } from '../context/WorkplaceServiceRequestContext';
import { useWorkplaceServiceRequestIframe } from '../hooks/useWorkplaceServiceRequestIframe';
import { useState } from 'react';
import { useConfig } from '../../../../context/ConfigContext';
export var Iframe = function (_a) {
    var _b;
    var onClose = _a.onClose, onSubmit = _a.onSubmit;
    var t = useTranslation('workplaceService').t;
    var _c = useConfig(), accessToken = _c.accessToken, tenantId = _c.tenantId;
    var _d = useWorkplaceServiceRequestContext(), iframePath = _d.iframePath, workplaceServiceFormRequest = _d.workplaceServiceFormRequest;
    var _e = useWorkplaceServiceRequestIframe(), handleSubmit = _e.handleSubmit, setChild = _e.setChild, child = _e.child, handleError = _e.handleError, loadingRequestService = _e.loadingRequestService;
    var _f = __read(useState(undefined), 2), totalPrice = _f[0], setTotalPrice = _f[1];
    return (_jsx(ExpandedDrawer, { onSubmit: function () { return handleSubmit(workplaceServiceFormRequest === null || workplaceServiceFormRequest === void 0 ? void 0 : workplaceServiceFormRequest.formAction); }, onClose: onClose, totalPrice: totalPrice, loading: loadingRequestService, isEditing: ((_b = workplaceServiceFormRequest === null || workplaceServiceFormRequest === void 0 ? void 0 : workplaceServiceFormRequest.formAction) === null || _b === void 0 ? void 0 : _b.type) === 'edit', children: _jsx(PenpalIframe, { id: "workplace-service-request-iframe", src: iframePath, setChild: setChild, onHeartbeatError: handleError, methods: {
                pingChild: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (child === null || child === void 0 ? void 0 : child.pingChild())];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                }); }); },
                getInitialValues: function () {
                    return workplaceServiceFormRequest;
                },
                getAccessToken: function () {
                    return accessToken;
                },
                getTenantId: function () {
                    return tenantId;
                },
                onTotalPriceChange: function (price) {
                    return setTotalPrice(price);
                },
                onSubmit: function () {
                    onSubmit();
                },
            }, title: t("iframe.title"), style: { width: '100%', height: '100%' } }) }));
};
